import advancedImg from './advanced.svg';
import allFundsImg from './all-funds.svg';
import amersImg from './amers.svg';
import apacImg from './apac.svg';
import bankImg from './Bank.svg';
import checkDoubleImg from './check-double.svg';
import commentImg from './comment.svg';
import countryImg from './country.svg';
import crossImg from './cross.svg';
import dataTypeImg from './data_type.svg';
import dataFieldsImg from './data-fields.svg';
import dividendsImg from './dividends.svg';
import doubleTickImg from './double-tick.svg';
import emeaImg from './emea.svg';
import endpointImg from './endpoint.svg';
import endpointWImg from './endpoint-w.svg';
import esgEarthImg from './esg-earth.svg';
import etfImg from './etf.svg';
import eventPremiumImg from './event-premium.svg';
import eventsImg from './events.svg';
import exchangesImg from './exchanges.svg';
import fileKeyImg from './file-key.svg';
import freeWImg from './free-w.svg';
import freeImg from './free.svg';
import fundamentalsImg from './fundamentals.svg';
import globalImg from './global.svg';
import historyImg from './history.svg';
import identifiersImg from './identifiers.svg';
import indexImg from './index.svg';
import industrialImg from './Industrial.svg';
import industryWealthImg from './industry-wealth.svg';
import industryImg from './industry.svg';
import insuranceImg from './Insurance.svg';
import investmentImg from './Investment.svg';
import japanImg from './japan.svg';
import kpiWealthImg from './KPI-wealth.svg';
import licenseTypeImg from './license-type.svg';
import packageImg from './package.svg';
import periodLabelImg from './period_label.svg';
import periodImg from './period.svg';
import priceHoldingImg from './price-holding.svg';
import pricingWImg from './pricing-w.svg';
import pricingImg from './pricing.svg';
import privateWImg from './private-w.svg';
import privateImg from './private.svg';
import professionalWImg from './professional-w.svg';
import professionalImg from './professional.svg';
import propertyImg from './Property.svg';
import referenceImg from './reference.svg';
import regionMapImg from './region-map.svg';
import regionImg from './region.svg';
import searchLightImg from './search-light.svg';
import segmentsWealthImg from './segments-wealth.svg';
import sharepointImg from './sharepoint.svg';
import symbologyImg from './symbology.svg';
import thirdPartyImg from './third-party.svg';
import tickImg from './tick.svg';
import timelineImg from './timeline.svg';
import topicImg from './topic.svg';
import userImg from './user.svg';
import vectorImg from './Vector.svg';
import xlsImg from './xls.svg';

const IMAGE_BY_NAME = {
  advanced: advancedImg,
  'all-funds': allFundsImg,
  amers: amersImg,
  apac: apacImg,
  Bank: bankImg,
  'check-double': checkDoubleImg,
  comment: commentImg,
  country: countryImg,
  cross: crossImg,
  data_type: dataTypeImg,
  'data-fields': dataFieldsImg,
  dividends: dividendsImg,
  'double-tick': doubleTickImg,
  emea: emeaImg,
  'esg-earth': esgEarthImg,
  endpoint: endpointImg,
  'endpoint-w': endpointWImg,
  etf: etfImg,
  'event-premium': eventPremiumImg,
  events: eventsImg,
  exchanges: exchangesImg,
  'file-key': fileKeyImg,
  'free-w': freeWImg,
  free: freeImg,
  fundamentals: fundamentalsImg,
  global: globalImg,
  history: historyImg,
  identifiers: identifiersImg,
  index: indexImg,
  Industrial: industrialImg,
  'industry-wealth': industryWealthImg,
  industry: industryImg,
  Insurance: insuranceImg,
  Investment: investmentImg,
  japan: japanImg,
  'KPI-wealth': kpiWealthImg,
  'license-type': licenseTypeImg,
  package: packageImg,
  period_label: periodLabelImg,
  period: periodImg,
  'price-holding': priceHoldingImg,
  pricing: pricingImg,
  'pricing-w': pricingWImg,
  'private-w': privateWImg,
  private: privateImg,
  'professional-w': professionalWImg,
  professional: professionalImg,
  Property: propertyImg,
  reference: referenceImg,
  'region-map': regionMapImg,
  region: regionImg,
  'search-light': searchLightImg,
  'segments-wealth': segmentsWealthImg,
  sharepoint: sharepointImg,
  symbology: symbologyImg,
  'third-party': thirdPartyImg,
  tick: tickImg,
  timeline: timelineImg,
  topic: topicImg,
  user: userImg,
  Vector: vectorImg,
  xls: xlsImg
};

export function resolveImage(name) {
  return IMAGE_BY_NAME[name] || '';
}

export {
  advancedImg,
  allFundsImg,
  amersImg,
  apacImg,
  bankImg,
  checkDoubleImg,
  commentImg,
  countryImg,
  crossImg,
  dataTypeImg,
  dataFieldsImg,
  dividendsImg,
  doubleTickImg,
  emeaImg,
  esgEarthImg,
  endpointImg,
  endpointWImg,
  etfImg,
  eventPremiumImg,
  eventsImg,
  exchangesImg,
  fileKeyImg,
  freeWImg,
  freeImg,
  fundamentalsImg,
  globalImg,
  historyImg,
  identifiersImg,
  indexImg,
  industrialImg,
  industryWealthImg,
  industryImg,
  insuranceImg,
  investmentImg,
  japanImg,
  kpiWealthImg,
  licenseTypeImg,
  packageImg,
  periodLabelImg,
  periodImg,
  priceHoldingImg,
  pricingImg,
  pricingWImg,
  privateWImg,
  privateImg,
  professionalWImg,
  professionalImg,
  propertyImg,
  referenceImg,
  regionMapImg,
  regionImg,
  searchLightImg,
  segmentsWealthImg,
  sharepointImg,
  symbologyImg,
  thirdPartyImg,
  tickImg,
  timelineImg,
  topicImg,
  userImg,
  vectorImg,
  xlsImg
};